<div class="fixed inset-0 z-50 bg-black/10">
  <div class="size-full bg-white shadow-xl">
    <div class="relative size-full">
      <!-- <div class="absolute top-0 right-0 left-0 z-50 bg-white/50 px-6 py-2">
        <ng-content select="[titlebar]" />
      </div> -->

      <ng-content />
    </div>
  </div>
</div>
